import { useEffect, useState } from "react";
import { WorkflowAddEdit } from "../components/common/formsCreateEdit/workflowAddEdit";
import useApi from "../utilities/useApi";
import { useParams, useNavigate } from 'react-router-dom';
import stringUtilities from "../utilities/stringUtilities";
import ErrorModal from "./common/errorModal";
import roleUtilities from "../utilities/roleUtilities";
import { Alert } from "react-bootstrap";

export default function EditWorkflow(props) {
    const { api } = useApi();
    const { organisationId, projectId, workflowId } = useParams();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [isComposite, setIsComposite] = useState(false);
    const [workflowTemplateId, setWorkflowTemplateId] = useState(null);
    const [workflowTemplates, setWorkflowTemplates] = useState([]);
    const [workflowType, setWorkflowType] = useState("9");
    const [hue, setHue] = useState(0);
    const [rgbColor, setRgbColor] = useState(null);
    const [order, setOrder] = useState("0");
    const [configuration, setConfiguration] = useState(null);
    const [canSave, setCanSave] = useState(false);
    const [error, setError] = useState(null);
    const [workflowHasData, setWorkflowHasData] = useState(false);
    const [alert, setAlert] = useState(null);
    const [configTypes, setConfigTypes] = useState([])
    const [configTypesTwo, setConfigTypesTwo] = useState([])
    const [icons, setIcons] = useState(null);
    const [isLoadingIcons, setIsLoadingIcons] = useState(false);

    const initialiseWorkflowTypeValue = (type) => {
        return (type !== 9 && type !== 10) ? 9 : type
    }

    const fetchWorkflowData = () => {
        api.getWorkflow(
            organisationId, projectId, workflowId,
            (data) => {
                setName(data.name);
                setIsComposite(data.isComposite);
                setWorkflowType(String(initialiseWorkflowTypeValue(data.workflowType)));
                setHue(data.hue);
                setRgbColor(stringUtilities.checkColorHash(data.color));
                setOrder(data.orderBy);
                setConfiguration(data.configuration);
                setWorkflowTemplateId(data.workflowTemplateId)
                if (data.configuration) {
                    const obj = JSON.parse(data.configuration)
                    setConfigTypes(obj.types ?? [])
                    setConfigTypesTwo(obj.types2 ?? [])
                }
            },
            () => { }
        )
    }

    useEffect(() => {
        fetchWorkflowData();

        api.getWorkflowTemplates(
            organisationId,
            data => setWorkflowTemplates(data),
            () => { }
        )

        setIsLoadingIcons(true);
        api.getIcons(organisationId,
            (data) => {
                setIcons(data);
                setIsLoadingIcons(false);
            },
            () => {
                setIsLoadingIcons(false);
            }
        )
    }, [])


    const handleSubmit = () => {
        api.editWorkflow(
            organisationId, projectId, workflowId,
            name, parseInt(order), JSON.stringify({"types": configTypes, "types2": configTypesTwo}), parseInt(workflowType), parseInt(hue), rgbColor, workflowTemplateId, isComposite,
            (data) => {
                if (data.isError) {
                    setError({ message: data.errorMessage });
                } else {
                    navigate(`/${organisationId}/projects/${projectId}/workflows`)
                }
            },
            () => { }
        )
    }

    const onSaveTemplate = (newTemplateName) => {
        api.addWorkflowTemplate(
            organisationId,
            newTemplateName, parseInt(order), configuration, parseInt(workflowType), parseInt(hue), rgbColor,
            () => navigate(`/${organisationId}/projects/${projectId}/workflows`),
            () => { },
        )
    }

    const handleWorkflowTemplateChange = (templateId) => {
        if (!stringUtilities.isNullOrEmpty(templateId)) {
            setWorkflowTemplateId(templateId);
            const selectedTemplate = workflowTemplates.find(item => item.id === templateId);
            setWorkflowType(String(initialiseWorkflowTypeValue(selectedTemplate.workflowTypeId)));
            setHue(selectedTemplate.hue);
            setRgbColor(stringUtilities.checkColorHash(selectedTemplate.color));
            setOrder(String(selectedTemplate.orderBy));
            setConfiguration(selectedTemplate.configuration ?? null);
            if (selectedTemplate.configuration) {
                const obj = JSON.parse(selectedTemplate.configuration)
                setConfigTypes(obj.types)
                setConfigTypesTwo(obj.types2)
            }
        } else {
            setWorkflowTemplateId(null);
        }
    }

    useEffect(() => setCanSave(!stringUtilities.isNullOrEmpty(name)), [name])
    
    useEffect(() => {
        api.getData(organisationId, projectId, null, null, [workflowId], null, null, null, null, null, null, 0, 0, null, false, null, false, null,
            (data) => {
                setWorkflowHasData(data.totalCount > 0)
                setAlert(data.totalCount > 0 ? <Alert variant='warning' className='d-flex align-items-center my-5'>
                    <i className='fi-alert-triange me-2 me-sm-3'></i>
                    <p className="m-0">This workflow has data attached to it, editing it may have negative consequences!</p>
                </Alert> : null);

            },
            () => { }
        );
    }, [])

    return (
        <>
            <WorkflowAddEdit
                title="Edit workflow"
                name={name}
                setName={setName}
                isComposite={isComposite}
                workflowTemplates={workflowTemplates}
                setIsComposite={setIsComposite}
                workflowTemplateId={workflowTemplateId}
                handleWorkflowTemplateChange={templateId => handleWorkflowTemplateChange(templateId)}
                workflowType={workflowType}
                setWorkflowType={setWorkflowType}
                hue={hue}
                setHue={setHue}
                rgbColor={rgbColor}
                setRgbColor={setRgbColor}
                order={order}
                setOrder={setOrder}
                canSave={ canSave && roleUtilities.hasOrgAdminCapability(props.user) }
                workflowHasData={workflowHasData}
                handleSubmit={handleSubmit}
                handleCancel={() => navigate(`/${organisationId}/projects/${projectId}/workflows`)}
                canSaveTemplate={stringUtilities.isNullOrEmpty(workflowTemplateId) && order !== undefined}
                handleSaveTemplate={newTemplateName => onSaveTemplate(newTemplateName)}
                alert={alert}
                configTypes={configTypes}
                configTypesTwo={configTypesTwo}
                setConfigTypes={setConfigTypes}
                setConfigTypesTwo={setConfigTypesTwo}
                icons={icons}
                isLoadingIcons={isLoadingIcons}
            />

            {error && error !== null &&
                <ErrorModal error={error} onDismiss={() => setError(null)} />
            }

        </>
    )
}